import { useContext } from 'react';

import { CoreContext } from './context.provider';

const useCoreProvider = () => {
  const context = useContext(CoreContext);

  return context ?? { errorBoundaryConfig: { ErrorBoundaryComponent: null } };
};

export { useCoreProvider };
